import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const navItemsLeft = [
    { label: 'Etapas', id: 'processo' },
    { label: 'Sobre', id: 'sobre' },
    { label: 'Ferramentas', id: 'calculadoras' },
    { label: 'Depoimentos', id: 'depoimentos' },
    { label: 'Planos', id: 'planos' },
  ];

  const navItemsRight = [
    { label: 'Projeto X', id: 'projeto-x' },
    { label: 'Locais de Atendimento', id: 'localizacao' },
    { label: 'Contato', id: 'contato' },
  ];

  const allNavItems = [...navItemsLeft, ...navItemsRight];

  return (
    <header className="absolute top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between py-2">

          {/* Menu Desktop */}
          <nav className="hidden lg:flex items-center w-full">
            {/* Left nav items */}
            <div className="flex items-center gap-5 xl:gap-7 flex-1 justify-end pr-6">
              {navItemsLeft.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm text-gray-600 hover:text-brand-green transition-colors whitespace-nowrap"
                  data-testid={`nav-${item.id}`}
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* Logo Central */}
            <img
              src="/assets/logo-tf.png"
              alt="Thiago Ferreira Nutricionista"
              className="h-20 flex-shrink-0"
              data-testid="header-logo"
            />

            {/* Right nav items + CTA */}
            <div className="flex items-center gap-5 xl:gap-7 flex-1 pl-6">
              {navItemsRight.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm text-gray-600 hover:text-brand-green transition-colors whitespace-nowrap"
                  data-testid={`nav-${item.id}`}
                >
                  {item.label}
                </button>
              ))}
              <a
                href="https://wa.me/5535988366028?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20agendar%20uma%20consulta.%20Poderia%20me%20informar%20sobre%20os%20planos%20de%20acompanhamento%20nutricional%20dispon%C3%ADveis%3F"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="header-cta-button"
                className="ml-auto border-2 border-brand-green text-brand-green px-5 py-2 rounded-full text-sm font-medium hover:bg-brand-green hover:text-white transition-all whitespace-nowrap"
              >
                Agende sua Consulta
              </a>
            </div>
          </nav>

          {/* Logo Mobile */}
          <img
            src="/assets/logo-tf.png"
            alt="Thiago Ferreira Nutricionista"
            className="h-12 lg:hidden"
          />

          {/* Menu Hamburguer Mobile */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-gray-600"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Menu Mobile */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 space-y-3">
            {allNavItems.map((item) => (
              <button key={item.id} onClick={() => scrollToSection(item.id)} className="block w-full text-left text-gray-600 hover:text-brand-green text-sm">
                {item.label}
              </button>
            ))}
            <a
              href="https://wa.me/5535988366028?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20agendar%20uma%20consulta.%20Poderia%20me%20informar%20sobre%20os%20planos%20de%20acompanhamento%20nutricional%20dispon%C3%ADveis%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center border-2 border-brand-green text-brand-green px-6 py-2 rounded-full text-sm font-medium hover:bg-brand-green hover:text-white transition-all"
            >
              Agende sua Consulta
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
